import { CONTINUOUS_EDUCATION } from '../../../api/endpoints';
import request from '../../../api/request';
import { Section } from '../../../api/requests/MantainerPortal';
import {
  PaginationQueryDto,
  PaginationRequestType,
} from '../../../types/paginationRequestType';
import {
  ContinuousEducationSectionFilters,
  ContinuousEducationSectionForm,
} from './types';

export const getContinuousEducationSectionsActionRequest = (
  params: PaginationQueryDto<ContinuousEducationSectionFilters>,
) => {
  return request<PaginationRequestType<Section>>(
    CONTINUOUS_EDUCATION.SECTIONS_PAGINATED,
    {
      params: {
        ...params,
        page: params.page - 1,
      },
    },
  );
};

export const getContinuousEducationSectionsFormActionRequest = () => {
  return request<ContinuousEducationSectionForm>(
    CONTINUOUS_EDUCATION.SECTIONS_FORM,
  );
};
